<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="section">
        @for (section of sections; let i = $index; track i) {
            <div class="section__section-container" [formGroupName]="section.id">
                <p class="section__header navy-text">{{section.name}}</p>
                @if (section.description) {
                    <span class="sub-header">{{section.description}}</span>
                }
                <div class="field" [style.grid-template-columns]="'repeat(' + (section.selection ? 1 : 4) + ', 1fr)'">
                    @for (field of section.fields; let i = $index; track i) {
                        <div
                            class="field__text-container"
                            [style.grid-column]="'span ' + ((field.type === infoFieldType.ZIP || field.type === infoFieldType.STATE) ? 1 : 2)">
                            <span class="field__input-label">
                                <b>{{field.name}}</b>
                                @if (field.detail) {
                                    ({{field.detail}})
                                }
                                @if (field.required) {
                                    {{"*"}}
                                }
                            </span>
                            @if (field.type === infoFieldType.TEXT || field.type === infoFieldType.EMAIL) {
                                    <input
                                        matInput
                                        type="text"
                                        [placeholder]="field.placeholder || ''"
                                        [formControlName]="field.id"
                                    />
                            }
                            @if (field.type === infoFieldType.ZIP) {
                                <input
                                    matInput
                                    [mask]="00000[-0000]"
                                    [dropSpecialCharacters]="false"
                                    [maxlength]="10"
                                    [formControlName]="field.id"
                                    placeholder="99999 or 99999-9999"
                                />
                            }
                            @if (field.type === infoFieldType.PHONE) {
                                <input
                                    matInput
                                    [mask]="'(000)000-0000'"
                                    [dropSpecialCharacters]="false"
                                    [formControlName]="field.id"
                                    placeholder="(999)999-9999"
                                />
                            }
                            @if (field.type === infoFieldType.STATE) {
                                <mat-form-field appearance="outline" class="w-full">
                                    <mat-select [formControlName]="field.id" (selectionChange)="onStateChange($event, section.id)">
                                        @for (state of states; track state) {
                                            <mat-option [value]="state">{{state.name}}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                @if (showSectionIdStateWarning.includes(section.id)) {
                                    <mat-hint class="warning-text">
                                        {{errorMessage}}
                                    </mat-hint>
                                }
                            }
                            @if (field.type === infoFieldType.PASSWORD) {
                                <mat-form-field appearance="outline" class="w-full">
                                    <input
                                        matInput
                                        [type]="hidePassword ? 'password' : 'text'"
                                        [formControlName]="field.id"
                                    />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        (click)="hidePassword = !hidePassword"
                                        [attr.aria-label]="'Hide password'"
                                        [attr.aria-pressed]="hidePassword"
                                        type="button">
                                        <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    </button>
                                </mat-form-field>
                                <div class="field__password-button-container">
                                    <button mat-stroked-button color="primary" class="field__password-button">Reset Password</button>
                                </div>
                            }
                            @if (field.type === infoFieldType.SELECTION) {
                                <div class="field__card-container">
                                    @for (selection of field.value; let i = $index; track i) {
                                        <mat-card class="field__card">
                                            @if (selection['editSelection'] === false) {
                                                <mat-card-content>
                                                    <p class="field__card-text navy-text">
                                                        <b>{{selection['name']}}</b>
                                                    </p>
                                                    <div class="field__card-actions">
                                                        <button mat-icon-button (click)="editProfile(field, i)">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                        <button mat-icon-button (click)="removeProfile(field, i)">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </div>
                                                </mat-card-content>
                                            }
                                            @else if (field.value && field.value[i]['editSelection'] === true) {
                                                <mat-card-content>
                                                    <mat-form-field appearance="outline" class="w-full">
                                                        <input
                                                            matInput
                                                            class="field__card-text-input navy-text"
                                                            type="text"
                                                            [formControlName]="field.value[i]['name']"
                                                        />
                                                    </mat-form-field>
                                                    <div class="field__card-actions">
                                                        <button mat-icon-button (click)="saveProfile(field, i)">
                                                            <mat-icon>check</mat-icon>
                                                        </button>
                                                        <button mat-icon-button (click)="cancelProfile(field, i)">
                                                            <mat-icon>close</mat-icon>
                                                        </button>
                                                    </div>
                                                </mat-card-content>
                                            }
                                        </mat-card>
                                    }
                                    <mat-card class="field__card" (click)="addProfile(field)">
                                        <mat-card-content>
                                            <mat-icon>add</mat-icon>
                                            <p class="field__card-text navy-text">
                                                <b>Add a profile</b>
                                            </p>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            }
                        </div>
                    }
                </div>
                @if (section.id === "basicInfo") {
                    <div class="section__checkbox">
                        <input type="checkbox" (change)="toggleCopyBasicInfo($event)"/>
                        <span class="section__header navy-text">Business Information same as Basic Information</span>
                    </div>
                }
            </div>
        }
    </div>
    <div class="save-button-container">
        <button mat-flat-button color="primary" type="submit">Save</button>
    </div>
</form>